import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  fetchCategories,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
} from "./category.actions";
import { of } from "rxjs";
import { map, mergeMap, catchError } from "rxjs/operators";
import { CategoryService } from "@services/index";

@Injectable()
export class CategoryEffects {
  loadCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCategories),
      mergeMap((action) =>
        this.categoryService
          .getCategories(action.page, action.filterOptions)
          .pipe(
            map((category) => {
              return fetchCategoriesSuccess({ category });
            }),
            catchError((error) => {
              return of(fetchCategoriesFailure({ error }));
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private categoryService: CategoryService
  ) {}
}
